// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cer-wrapper[data-v-6999c6ec]{-webkit-box-flex:0;-ms-flex:0 0 33.33%;flex:0 0 33.33%;max-width:33.33%}.cer-img[data-v-6999c6ec]{width:100%;height:74px;min-height:74px;max-width:74px}", ""]);
// Exports
module.exports = exports;
